var map = {
	"./AaveVaultLong": 45,
	"./AaveVaultLong.json": 45,
	"./Address": 46,
	"./Address.json": 46,
	"./Context": 47,
	"./Context.json": 47,
	"./DataTypes": 48,
	"./DataTypes.json": 48,
	"./FlashLoanReceiverBase": 49,
	"./FlashLoanReceiverBase.json": 49,
	"./GhstVaultLong": 50,
	"./GhstVaultLong.json": 50,
	"./HelperAdmin": 27,
	"./HelperAdmin.json": 27,
	"./IERC20": 31,
	"./IERC20.json": 31,
	"./IERC20StableCoin": 32,
	"./IERC20StableCoin.json": 32,
	"./IFlashLoanReceiver": 51,
	"./IFlashLoanReceiver.json": 51,
	"./ILendingPool": 52,
	"./ILendingPool.json": 52,
	"./ILendingPoolAddressesProvider": 53,
	"./ILendingPoolAddressesProvider.json": 53,
	"./IUniswapV2Factory": 54,
	"./IUniswapV2Factory.json": 54,
	"./IUniswapV2Pair": 55,
	"./IUniswapV2Pair.json": 55,
	"./IUniswapV2Router": 56,
	"./IUniswapV2Router.json": 56,
	"./IVaultLongMaiFinance": 57,
	"./IVaultLongMaiFinance.json": 57,
	"./LinkVaultLong": 58,
	"./LinkVaultLong.json": 58,
	"./Migrations": 59,
	"./Migrations.json": 59,
	"./Ownable": 60,
	"./Ownable.json": 60,
	"./SafeERC20": 61,
	"./SafeERC20.json": 61,
	"./VaultLongMaiFinanceBase": 62,
	"./VaultLongMaiFinanceBase.json": 62,
	"./WbtcVaultLong": 63,
	"./WbtcVaultLong.json": 63,
	"./WethVaultLong": 64,
	"./WethVaultLong.json": 64
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37;